import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/main/bootstrap/alert/AlertService';
import { ToastService } from 'src/app/main/bootstrap/toast/ToastService';
import { clearLocalStorage } from 'src/app/main/service/clear-localstorage';
import { ApiService } from 'src/services/api.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  loading: boolean = false;
  resetPasswordForm: FormGroup;
  resetPasswordForm2: FormGroup;
  submitted: boolean = false;

  step: number = 1;

  hash: string = "";

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public apiService: ApiService,
    private alertService: AlertService,
    public toastService: ToastService) {
    clearLocalStorage();
    localStorage.removeItem('regInfo');
    localStorage.removeItem('paymentInfo');
    this.resetPasswordForm = this.formBuilder.group({
      username: ['', Validators.required]
    });
    // this.route
  }

  ngOnInit(): void {

  }

  get resetPasswordFormControl() {
    return this.resetPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetPasswordForm.valid) {
      this.loading = true;
      this.apiService.post_("/auth/reset-password", this.resetPasswordForm.value)
      .pipe(finalize(() => {
        this.loading = false;
      })).subscribe(response => {
        if (response.success && response.status == "OK") {
          this.loading = false;
          let message = "A Password reset link has been sent to the email address associated with this username!";
          this.alertService.alertSuccess(message);
          // this.toastService.showDanger(message);
        }
        else {
          this.toastService.showDanger(response.message);
        }
      },
      err => {console.log(err)});
    }
  }

  onSubmitStep2() {
    this.submitted = true;
    if (this.resetPasswordForm2.valid) {

    }
  }


}
